module.exports = __webpack_public_path__ + "img/盖章@2x.24c64762.png";